var Localization = window.Localization = (function () {
    var hashCode: string;
    var culture: string;
    var allResources;

    var resourcesByType;

    function get(key, defaultValue) {
        if (this[key] == undefined)
            return defaultValue;
        else return this[key];
    }

    function init(version: string, cultureName: string) {

        hashCode = version;
        culture = cultureName;

        $.ajax("/resources/allresources/" + hashCode, {
            data: {},
            success: resp => {

                allResources = resp.ActionData.resources;
            },
            async: false
        });

        resourcesByType = {};

        for (var i in allResources) {
            resourcesByType[allResources[i].Type] = getResource(allResources[i].Type, allResources[i].HashCodes[culture]);
        }
    }

    function getString(resourceKey: string, defaultValue: string) {
        const [type, key] = resourceKey.split('.');
        return key && resourcesByType[type]?.[key] ? resourcesByType[type][key] : defaultValue;
    }

    function getResource(type: string, version: string): JSON {
        var a: JSON;

        $.ajax("/resources/get/" + type + "/" + version, {
            data: { typeString: type },
            success: response => {
                a = response.ActionData.res;
            },
            async: false
        });

        return a;
    }

    function getLanguage() {
        return (<any>window).globalAppSettings.lang; //TODO: get from cookie
    }

    function changeLanguage(lang: string) {
        const currentPath = window.location.pathname;
        const currentLang = getLanguage();

        if (currentPath === `/${currentLang}` || currentPath.startsWith(`/${currentLang}/`)) {
            window.location.href = `/${lang}` + currentPath.substring(3);
        }
    }

    return {
        get,
        init,
        getString,
        getLanguage,
        changeLanguage
    }
})()


